module.exports = __webpack_public_path__ + "static/media/Cera-Pro-Regular.74984ed0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/cera/Cera-Pro-Regular.woff
// module id = 162
// module chunks = 56